/**
 * State helpers for infinite scroll (ready gate around IntersectionObserver).
 */
class InfiniteScrollDelegate {
    initialReadyFromProps(props) {
        return props.initialDelayMs <= 0;
    }

    setReady(ready, callback) {
        this.setState({ ready }, callback);
    }
}

export default InfiniteScrollDelegate;
